import * as ko from 'knockout';
import 'jquery';
import 'xEditable';

import { Event } from 'Core/Common/Event';

import { IValueUpdater } from 'LookupEditor/Interfaces/IValueUpdater';
import { IColumnValue } from 'LookupEditor/Interfaces/IColumnValue';
import { EditableColumnModel } from 'LookupEditor/Models/EditableColumnModel';

import CommonTemplate from 'LookupEditor/Templates/Columns/Common.html';
ko.templates['LookupEditor/Templates/Columns/Common'] = CommonTemplate;

export abstract class ColumnEditor extends Event {
    protected template: string;
    protected emptyLookupValue: string = '-';
    protected _el: HTMLElement;

    constructor(protected column: EditableColumnModel) {
        super();
        this.template = '';
        this._el = null;
    }

    GetTemplateName(): string {
        return 'LookupEditor/Templates/Columns/Common';
    }

    AfterRender(el, owner: IValueUpdater, columnName, format): void {
        if (el) {
            this._el = el[0];
        }
        ($.fn.editable as any).defaults.mode = 'inline';
        $(el).editable({
            type: 'text',
            success: (response, newValue) => {
                const value: IColumnValue = {
                    Name: columnName,
                    Value: newValue,
                };

                owner.UpdateValue(value);
            },
        });
    }

    GetWrapper(): HTMLElement {
        return this._el;
    }

    abstract ToString();
}
